'use client';

import { useParams } from 'next/navigation';
import { FormsortStepWrapper } from '../components/FormsortStepWrapper';
import { NativeStepRenderer } from '../components/NativeStepRenderer';
import { WizardLayout } from '../components/WizardLayout';
import { useWizardContext } from '../hooks/useWizardContext';
import { useWizardNavigation } from '../hooks/useWizardNavigation';

/**
 * Dynamic step page that renders the appropriate step component
 * based on the step slug in the URL.
 */
export default function StepPage() {
  const params = useParams();
  const stepSlug = params.step as string;
  const { state } = useWizardContext();
  const { currentStep, visibleSteps, currentStepIndex } = useWizardNavigation();

  // Show loading while session is being restored
  if (state.isLoading) {
    return (
      <WizardLayout currentStepIndex={0} totalSteps={1}>
        <div className='flex flex-1 items-center justify-center'>
          <div className='border-sh-sky h-8 w-8 animate-spin rounded-full border-b-2' />
        </div>
      </WizardLayout>
    );
  }

  // Handle invalid step
  if (!currentStep) {
    return (
      <WizardLayout currentStepIndex={0} totalSteps={visibleSteps.length}>
        <div className='flex flex-1 items-center justify-center'>
          <p className='text-sh-gray-dark'>
            The step &quot;{stepSlug}&quot; was not found.
          </p>
        </div>
      </WizardLayout>
    );
  }

  return (
    <WizardLayout
      currentStepIndex={currentStepIndex}
      totalSteps={visibleSteps.length}
      hideMobileBackButton={
        stepSlug === 'location-check' || stepSlug === 'quote-edit'
      }
    >
      {currentStep.component === 'formsort' ? (
        <FormsortStepWrapper stepConfig={currentStep} />
      ) : (
        <NativeStepRenderer stepConfig={currentStep} />
      )}
    </WizardLayout>
  );
}
